module.exports = __webpack_public_path__ + "static/media/indorse-logo.cf61346f.png";